/* eslint-disable object-curly-newline */

export default {
	status: 200,
	data: {
		code: 200,
		file: {
			height: 79,
			name: 'cute dog',
			url: 'https://www.washingtonpost.com/resizer/LC0UahHNg_1BPgG35QyiUNKDqvc=/1023x0/smart/arc-anglerfish-washpost-prod-washpost.s3.amazonaws.com/public/HB4AT3D3IMI6TMPTWIZ74WAR54.jpg',
			width: 1166,
		},
	},
};
